import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as QuoteIcon } from "assets/images/iconsV2/quote-request.svg";

export default function NoQuotesSubmitted({ children }: { children: ReactNode }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <QuoteIcon />
      <p className="font-semibold text-md mt-lg">
        <FormattedMessage id="quote.noQuoteSubmitted" defaultMessage="No quotes submitted yet" />
      </p>
      {children}
    </div>
  );
}
